function getNumberMask(value: string): string {
  if (!value) { return value; }

  /*
  // Lógica anterior: separadores decimal e de milhar definidos pela localidade,
  // com apenas um separador decimal permitido.
  const locale = navigator.language; // "pt-BR", "en-US"

  const numberParts = new Intl.NumberFormat(locale).formatToParts(1000.1);
  const decimalSeparator = numberParts.find((p) => p.type === "decimal")?.value ?? ".";
  const thousandsSeparator = numberParts.find((p) => p.type === "group")?.value ?? (decimalSeparator === "," ? "." : ",");

  const allowedChars = new RegExp(`[^\\d\\-\\${decimalSeparator}\\${thousandsSeparator}]`, "g");
  let result = value.replace(allowedChars, "");
  result = result.replace(/(?!^)-/g, "");

  const parts = result.split(decimalSeparator);
  if (parts.length > 2) {
    result = parts[0] + decimalSeparator + parts.slice(1).join("");
  }

  return result;
  */

  const hasLeadingNegative = value.startsWith("-");
  const digitsAndCommas = value.replace(/[^\d,]/g, "");

  return `${hasLeadingNegative ? "-" : ""}${digitsAndCommas}`;
}

const normalizeToFloat = (value: unknown): number | null | undefined => {
  if (value === "" || value === null || value === undefined) {
    return null;
  }
  if (typeof value === "number") {
    return value;
  }
  const stringValue = value.toString().trim();

  const locale = navigator.language;
  const numberParts = new Intl.NumberFormat(locale).formatToParts(1000.1);
  const decimalSeparator = numberParts.find((p) => p.type === "decimal")?.value ?? ".";
  const thousandsSeparator = numberParts.find((p) => p.type === "group")?.value ?? (decimalSeparator === "," ? "." : ",");

  if (decimalSeparator !== "." && stringValue.includes(".") && !stringValue.includes(decimalSeparator)) {
    const looksLikeThousands = thousandsSeparator === "." && /^-?\d{1,3}(\.\d{3})+$/.test(stringValue);
    if (!looksLikeThousands) {
      const num = Number(stringValue);
      if (!isNaN(num)) {
        return num;
      }
    }
  }

  if (!stringValue.includes(decimalSeparator)) {
    const parsed = parseFloat(stringValue.replace(new RegExp(`\\${thousandsSeparator}`, "g"), ""));
    return isNaN(parsed) ? null : parsed;
  }

  const normalized = stringValue
    .replace(new RegExp(`\\${thousandsSeparator}`, "g"), "")
    .replace(decimalSeparator, ".");

  const parsed = parseFloat(normalized);
  return isNaN(parsed) ? null : parsed;
};

const formatLocaleValue = (val: unknown): string => {
  if (val === undefined || val === null || val === "") return "";
  const locale = navigator.language;
  const numberParts = new Intl.NumberFormat(locale).formatToParts(1000.1);
  const decimalSeparator = numberParts.find((p) => p.type === "decimal")?.value ?? ".";
  let strVal = val.toString();
  
  if (typeof val === "number") {
    // If it's a number, convert the JS dot decimal separator to locale decimal separator
    strVal = val.toString().replace(".", decimalSeparator);
  } else if (decimalSeparator === "," && /^[+-]?\d+(\.\d+)?$/.test(strVal)) {
    strVal = strVal.replace(".", ",");
  } else if (decimalSeparator === "." && /^[+-]?\d+(,\d+)?$/.test(strVal)) {
    strVal = strVal.replace(",", ".");
  }
  return getNumberMask(strVal);
};

export { getNumberMask, normalizeToFloat, formatLocaleValue };
